import React from 'react';
import { usePageSEO } from '../hooks/usePageSEO';
import { organizationSchema, websiteSchema, faqSchema } from '../utils/structuredData';
import { HeroSection } from '../components/home/HeroSection';
import { AuthoritySection } from '../components/home/AuthoritySection';
import { WhatWeDoSection } from '../components/home/WhatWeDoSection';
import { ServicesSection } from '../components/home/ServicesSection';
import { ProductsSection } from '../components/home/ProductsSection';
import { LatestReleaseSection } from '../components/home/LatestReleaseSection';
import { PortfolioSection } from '../components/home/PortfolioSection';
import { WhyChooseUsSection } from '../components/home/WhyChooseUsSection';
import { ProcessSection } from '../components/home/ProcessSection';
import { TrustedBySection } from '../components/home/TrustedBySection';
import { FeaturedRecognitionSection } from '../components/home/FeaturedRecognitionSection';
import { CTASection } from '../components/home/CTASection';
export function HomePage() {
  usePageSEO({
    canonical: '/',
    keywords: 'Shopify development agency, Shopify experts, custom Shopify themes, Shopify app development, ecommerce conversion optimization, Fiverr Pro Shopify developer',
    jsonLd: [organizationSchema, websiteSchema, faqSchema([{
      question: 'What does Design Flow Digitals do?',
      answer: 'Design Flow Digitals is a premium Shopify development agency. We build custom Shopify themes, develop high-performance Shopify apps, create full ecommerce stores, and run conversion rate optimization for merchants worldwide.'
    }, {
      question: 'How many Shopify stores has Design Flow Digitals built?',
      answer: 'Design Flow Digitals has delivered more than 1,000 Shopify stores for global brands and entrepreneurs.'
    }, {
      question: 'Who founded Design Flow Digitals?',
      answer: 'Design Flow Digitals was founded by Pankaj Maurya, a full-stack Shopify developer with a Master of Commerce and a Fiverr Pro profile, vetted through Fiverr’s professional review process.'
    }, {
      question: 'Which Shopify apps does Design Flow Digitals offer?',
      answer: 'Design Flow Digitals offers two live Shopify apps: SEO Suite, an all in one Shopify SEO toolkit, and AI Photoshoot, an AI powered product photography app.'
    }])],
    title: 'Design Flow Digitals',
    description: 'Design Flow Digitals is a premium Shopify development agency with 1,000+ stores delivered. We specialize in custom themes, high-performance apps, and conversion-focused ecommerce stores for global merchants.'
  });
  return <div className="flex flex-col w-full" data-id="element-1042" data-mp="1pzu7pim4l5m0">
      <HeroSection data-id="element-1043" data-mp="1pyj69pg5k9y2" />
      <AuthoritySection data-id="element-1044" data-mp="1pxzny7mlbjji" />
      <WhatWeDoSection data-id="element-1045" data-mp="1pxhlgt9c4935" />
      <ServicesSection data-id="element-1046" data-mp="1l19a7qy9d019" />
      <ProductsSection data-id="element-1047" data-mp="1kzy4hll95i7i" />
      <LatestReleaseSection data-id="element-1048" data-mp="1l0hdgcsxcw9e" />
      <PortfolioSection data-id="element-1049" data-mp="iov7u51e8ly" />
      <WhyChooseUsSection data-id="element-1050" data-mp="if4u5g2xzfq" />
      <ProcessSection data-id="element-1051" data-mp="h44ygpr9btw" />
      <TrustedBySection data-id="element-1052" data-mp="gm1p04odxch" />
      <FeaturedRecognitionSection data-id="element-1053" data-mp="595dpsnpskf6" />
      <CTASection data-id="element-1054" data-mp="5a70uvi08xd9" />
    </div>;
}